"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
module.exports = {
  getBlocks: function getBlocks() {
    return {
      learning_title_regression: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_regression_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_regression'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_regression'],
        events: {}
      },
      set_regression_option: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.train_param_learningRate, 'learningRate'], [Lang.AiLearning.train_param_epochs, 'epochs'], [Lang.AiLearning.train_param_validationRate, 'validationRate']],
          value: 'learningRate',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          type: 'set_regression_option'
        },
        pyHelpDef: {
          params: [],
          type: 'set_regression_option'
        },
        paramsKeyMap: {
          OPTION: 0,
          VALUE: 1
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_regression'],
        func: function func(sprite, script) {
          var option = script.getField('OPTION', script);
          var value = script.getNumberValue('VALUE', script);
          Entry.aiLearning.setTrainOption(option, parseFloat(value));
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_1: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning, _Entry$aiLearning$get;
            var table = (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || (_Entry$aiLearning$get = _Entry$aiLearning.getTableData) === null || _Entry$aiLearning$get === void 0 ? void 0 : _Entry$aiLearning$get.call(_Entry$aiLearning);
            if (table) {
              var _Entry$aiLearning2, _Entry$aiLearning2$ge, _select$;
              var _Entry$aiLearning$get2 = (_Entry$aiLearning2 = Entry.aiLearning) === null || _Entry$aiLearning2 === void 0 || (_Entry$aiLearning2$ge = _Entry$aiLearning2.getTableData) === null || _Entry$aiLearning2$ge === void 0 ? void 0 : _Entry$aiLearning2$ge.call(_Entry$aiLearning2),
                _Entry$aiLearning$get3 = _Entry$aiLearning$get2.select,
                select = _Entry$aiLearning$get3 === void 0 ? [] : _Entry$aiLearning$get3,
                _Entry$aiLearning$get4 = _Entry$aiLearning$get2.fields,
                fields = _Entry$aiLearning$get4 === void 0 ? [] : _Entry$aiLearning$get4;
              return fields[select === null || select === void 0 || (_select$ = select[0]) === null || _select$ === void 0 ? void 0 : _select$[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_1'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_1'
        },
        paramsKeyMap: {
          ATTR1: 1
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_1'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var x;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  _context.next = 1;
                  return Entry.aiLearning.predict(x);
                case 1:
                  return _context.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_2: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning3, _Entry$aiLearning3$ge;
            var table = (_Entry$aiLearning3 = Entry.aiLearning) === null || _Entry$aiLearning3 === void 0 || (_Entry$aiLearning3$ge = _Entry$aiLearning3.getTableData) === null || _Entry$aiLearning3$ge === void 0 ? void 0 : _Entry$aiLearning3$ge.call(_Entry$aiLearning3);
            if (table) {
              var _Entry$aiLearning4, _Entry$aiLearning4$ge, _select$2;
              var _Entry$aiLearning$get5 = (_Entry$aiLearning4 = Entry.aiLearning) === null || _Entry$aiLearning4 === void 0 || (_Entry$aiLearning4$ge = _Entry$aiLearning4.getTableData) === null || _Entry$aiLearning4$ge === void 0 ? void 0 : _Entry$aiLearning4$ge.call(_Entry$aiLearning4),
                _Entry$aiLearning$get6 = _Entry$aiLearning$get5.select,
                select = _Entry$aiLearning$get6 === void 0 ? [] : _Entry$aiLearning$get6,
                _Entry$aiLearning$get7 = _Entry$aiLearning$get5.fields,
                fields = _Entry$aiLearning$get7 === void 0 ? [] : _Entry$aiLearning$get7;
              return fields[select === null || select === void 0 || (_select$2 = select[0]) === null || _select$2 === void 0 ? void 0 : _select$2[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning5, _Entry$aiLearning5$ge;
            var table = (_Entry$aiLearning5 = Entry.aiLearning) === null || _Entry$aiLearning5 === void 0 || (_Entry$aiLearning5$ge = _Entry$aiLearning5.getTableData) === null || _Entry$aiLearning5$ge === void 0 ? void 0 : _Entry$aiLearning5$ge.call(_Entry$aiLearning5);
            if (table) {
              var _Entry$aiLearning6, _Entry$aiLearning6$ge, _select$3;
              var _Entry$aiLearning$get8 = (_Entry$aiLearning6 = Entry.aiLearning) === null || _Entry$aiLearning6 === void 0 || (_Entry$aiLearning6$ge = _Entry$aiLearning6.getTableData) === null || _Entry$aiLearning6$ge === void 0 ? void 0 : _Entry$aiLearning6$ge.call(_Entry$aiLearning6),
                _Entry$aiLearning$get9 = _Entry$aiLearning$get8.select,
                select = _Entry$aiLearning$get9 === void 0 ? [] : _Entry$aiLearning$get9,
                _Entry$aiLearning$get0 = _Entry$aiLearning$get8.fields,
                fields = _Entry$aiLearning$get0 === void 0 ? [] : _Entry$aiLearning$get0;
              return fields[select === null || select === void 0 || (_select$3 = select[0]) === null || _select$3 === void 0 ? void 0 : _select$3[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_2'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_2'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_2'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var x, y;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  _context2.next = 1;
                  return Entry.aiLearning.predict([x, y]);
                case 1:
                  return _context2.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_3: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning7, _Entry$aiLearning7$ge;
            var table = (_Entry$aiLearning7 = Entry.aiLearning) === null || _Entry$aiLearning7 === void 0 || (_Entry$aiLearning7$ge = _Entry$aiLearning7.getTableData) === null || _Entry$aiLearning7$ge === void 0 ? void 0 : _Entry$aiLearning7$ge.call(_Entry$aiLearning7);
            if (table) {
              var _Entry$aiLearning8, _Entry$aiLearning8$ge, _select$4;
              var _Entry$aiLearning$get1 = (_Entry$aiLearning8 = Entry.aiLearning) === null || _Entry$aiLearning8 === void 0 || (_Entry$aiLearning8$ge = _Entry$aiLearning8.getTableData) === null || _Entry$aiLearning8$ge === void 0 ? void 0 : _Entry$aiLearning8$ge.call(_Entry$aiLearning8),
                _Entry$aiLearning$get10 = _Entry$aiLearning$get1.select,
                select = _Entry$aiLearning$get10 === void 0 ? [] : _Entry$aiLearning$get10,
                _Entry$aiLearning$get11 = _Entry$aiLearning$get1.fields,
                fields = _Entry$aiLearning$get11 === void 0 ? [] : _Entry$aiLearning$get11;
              return fields[select === null || select === void 0 || (_select$4 = select[0]) === null || _select$4 === void 0 ? void 0 : _select$4[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning9, _Entry$aiLearning9$ge;
            var table = (_Entry$aiLearning9 = Entry.aiLearning) === null || _Entry$aiLearning9 === void 0 || (_Entry$aiLearning9$ge = _Entry$aiLearning9.getTableData) === null || _Entry$aiLearning9$ge === void 0 ? void 0 : _Entry$aiLearning9$ge.call(_Entry$aiLearning9);
            if (table) {
              var _Entry$aiLearning0, _Entry$aiLearning0$ge, _select$5;
              var _Entry$aiLearning$get12 = (_Entry$aiLearning0 = Entry.aiLearning) === null || _Entry$aiLearning0 === void 0 || (_Entry$aiLearning0$ge = _Entry$aiLearning0.getTableData) === null || _Entry$aiLearning0$ge === void 0 ? void 0 : _Entry$aiLearning0$ge.call(_Entry$aiLearning0),
                _Entry$aiLearning$get13 = _Entry$aiLearning$get12.select,
                select = _Entry$aiLearning$get13 === void 0 ? [] : _Entry$aiLearning$get13,
                _Entry$aiLearning$get14 = _Entry$aiLearning$get12.fields,
                fields = _Entry$aiLearning$get14 === void 0 ? [] : _Entry$aiLearning$get14;
              return fields[select === null || select === void 0 || (_select$5 = select[0]) === null || _select$5 === void 0 ? void 0 : _select$5[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning1, _Entry$aiLearning1$ge;
            var table = (_Entry$aiLearning1 = Entry.aiLearning) === null || _Entry$aiLearning1 === void 0 || (_Entry$aiLearning1$ge = _Entry$aiLearning1.getTableData) === null || _Entry$aiLearning1$ge === void 0 ? void 0 : _Entry$aiLearning1$ge.call(_Entry$aiLearning1);
            if (table) {
              var _Entry$aiLearning10, _Entry$aiLearning10$g, _select$6;
              var _Entry$aiLearning$get15 = (_Entry$aiLearning10 = Entry.aiLearning) === null || _Entry$aiLearning10 === void 0 || (_Entry$aiLearning10$g = _Entry$aiLearning10.getTableData) === null || _Entry$aiLearning10$g === void 0 ? void 0 : _Entry$aiLearning10$g.call(_Entry$aiLearning10),
                _Entry$aiLearning$get16 = _Entry$aiLearning$get15.select,
                select = _Entry$aiLearning$get16 === void 0 ? [] : _Entry$aiLearning$get16,
                _Entry$aiLearning$get17 = _Entry$aiLearning$get15.fields,
                fields = _Entry$aiLearning$get17 === void 0 ? [] : _Entry$aiLearning$get17;
              return fields[select === null || select === void 0 || (_select$6 = select[0]) === null || _select$6 === void 0 ? void 0 : _select$6[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_3'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_3'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_3'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            var x, y, z;
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  z = script.getNumberValue('ATTR3', script);
                  _context3.next = 1;
                  return Entry.aiLearning.predict([x, y, z]);
                case 1:
                  return _context3.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_4: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning11, _Entry$aiLearning11$g;
            var table = (_Entry$aiLearning11 = Entry.aiLearning) === null || _Entry$aiLearning11 === void 0 || (_Entry$aiLearning11$g = _Entry$aiLearning11.getTableData) === null || _Entry$aiLearning11$g === void 0 ? void 0 : _Entry$aiLearning11$g.call(_Entry$aiLearning11);
            if (table) {
              var _Entry$aiLearning12, _Entry$aiLearning12$g, _select$7;
              var _Entry$aiLearning$get18 = (_Entry$aiLearning12 = Entry.aiLearning) === null || _Entry$aiLearning12 === void 0 || (_Entry$aiLearning12$g = _Entry$aiLearning12.getTableData) === null || _Entry$aiLearning12$g === void 0 ? void 0 : _Entry$aiLearning12$g.call(_Entry$aiLearning12),
                _Entry$aiLearning$get19 = _Entry$aiLearning$get18.select,
                select = _Entry$aiLearning$get19 === void 0 ? [] : _Entry$aiLearning$get19,
                _Entry$aiLearning$get20 = _Entry$aiLearning$get18.fields,
                fields = _Entry$aiLearning$get20 === void 0 ? [] : _Entry$aiLearning$get20;
              return fields[select === null || select === void 0 || (_select$7 = select[0]) === null || _select$7 === void 0 ? void 0 : _select$7[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning13, _Entry$aiLearning13$g;
            var table = (_Entry$aiLearning13 = Entry.aiLearning) === null || _Entry$aiLearning13 === void 0 || (_Entry$aiLearning13$g = _Entry$aiLearning13.getTableData) === null || _Entry$aiLearning13$g === void 0 ? void 0 : _Entry$aiLearning13$g.call(_Entry$aiLearning13);
            if (table) {
              var _Entry$aiLearning14, _Entry$aiLearning14$g, _select$8;
              var _Entry$aiLearning$get21 = (_Entry$aiLearning14 = Entry.aiLearning) === null || _Entry$aiLearning14 === void 0 || (_Entry$aiLearning14$g = _Entry$aiLearning14.getTableData) === null || _Entry$aiLearning14$g === void 0 ? void 0 : _Entry$aiLearning14$g.call(_Entry$aiLearning14),
                _Entry$aiLearning$get22 = _Entry$aiLearning$get21.select,
                select = _Entry$aiLearning$get22 === void 0 ? [] : _Entry$aiLearning$get22,
                _Entry$aiLearning$get23 = _Entry$aiLearning$get21.fields,
                fields = _Entry$aiLearning$get23 === void 0 ? [] : _Entry$aiLearning$get23;
              return fields[select === null || select === void 0 || (_select$8 = select[0]) === null || _select$8 === void 0 ? void 0 : _select$8[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning15, _Entry$aiLearning15$g;
            var table = (_Entry$aiLearning15 = Entry.aiLearning) === null || _Entry$aiLearning15 === void 0 || (_Entry$aiLearning15$g = _Entry$aiLearning15.getTableData) === null || _Entry$aiLearning15$g === void 0 ? void 0 : _Entry$aiLearning15$g.call(_Entry$aiLearning15);
            if (table) {
              var _Entry$aiLearning16, _Entry$aiLearning16$g, _select$9;
              var _Entry$aiLearning$get24 = (_Entry$aiLearning16 = Entry.aiLearning) === null || _Entry$aiLearning16 === void 0 || (_Entry$aiLearning16$g = _Entry$aiLearning16.getTableData) === null || _Entry$aiLearning16$g === void 0 ? void 0 : _Entry$aiLearning16$g.call(_Entry$aiLearning16),
                _Entry$aiLearning$get25 = _Entry$aiLearning$get24.select,
                select = _Entry$aiLearning$get25 === void 0 ? [] : _Entry$aiLearning$get25,
                _Entry$aiLearning$get26 = _Entry$aiLearning$get24.fields,
                fields = _Entry$aiLearning$get26 === void 0 ? [] : _Entry$aiLearning$get26;
              return fields[select === null || select === void 0 || (_select$9 = select[0]) === null || _select$9 === void 0 ? void 0 : _select$9[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning17, _Entry$aiLearning17$g;
            var table = (_Entry$aiLearning17 = Entry.aiLearning) === null || _Entry$aiLearning17 === void 0 || (_Entry$aiLearning17$g = _Entry$aiLearning17.getTableData) === null || _Entry$aiLearning17$g === void 0 ? void 0 : _Entry$aiLearning17$g.call(_Entry$aiLearning17);
            if (table) {
              var _Entry$aiLearning18, _Entry$aiLearning18$g, _select$0;
              var _Entry$aiLearning$get27 = (_Entry$aiLearning18 = Entry.aiLearning) === null || _Entry$aiLearning18 === void 0 || (_Entry$aiLearning18$g = _Entry$aiLearning18.getTableData) === null || _Entry$aiLearning18$g === void 0 ? void 0 : _Entry$aiLearning18$g.call(_Entry$aiLearning18),
                _Entry$aiLearning$get28 = _Entry$aiLearning$get27.select,
                select = _Entry$aiLearning$get28 === void 0 ? [] : _Entry$aiLearning$get28,
                _Entry$aiLearning$get29 = _Entry$aiLearning$get27.fields,
                fields = _Entry$aiLearning$get29 === void 0 ? [] : _Entry$aiLearning$get29;
              return fields[select === null || select === void 0 || (_select$0 = select[0]) === null || _select$0 === void 0 ? void 0 : _select$0[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_4'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_4'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_4'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var a, b, c, d;
            return _regenerator["default"].wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  _context4.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d]);
                case 1:
                  return _context4.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_5: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning19, _Entry$aiLearning19$g;
            var table = (_Entry$aiLearning19 = Entry.aiLearning) === null || _Entry$aiLearning19 === void 0 || (_Entry$aiLearning19$g = _Entry$aiLearning19.getTableData) === null || _Entry$aiLearning19$g === void 0 ? void 0 : _Entry$aiLearning19$g.call(_Entry$aiLearning19);
            if (table) {
              var _Entry$aiLearning20, _Entry$aiLearning20$g, _select$1;
              var _Entry$aiLearning$get30 = (_Entry$aiLearning20 = Entry.aiLearning) === null || _Entry$aiLearning20 === void 0 || (_Entry$aiLearning20$g = _Entry$aiLearning20.getTableData) === null || _Entry$aiLearning20$g === void 0 ? void 0 : _Entry$aiLearning20$g.call(_Entry$aiLearning20),
                _Entry$aiLearning$get31 = _Entry$aiLearning$get30.select,
                select = _Entry$aiLearning$get31 === void 0 ? [] : _Entry$aiLearning$get31,
                _Entry$aiLearning$get32 = _Entry$aiLearning$get30.fields,
                fields = _Entry$aiLearning$get32 === void 0 ? [] : _Entry$aiLearning$get32;
              return fields[select === null || select === void 0 || (_select$1 = select[0]) === null || _select$1 === void 0 ? void 0 : _select$1[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning21, _Entry$aiLearning21$g;
            var table = (_Entry$aiLearning21 = Entry.aiLearning) === null || _Entry$aiLearning21 === void 0 || (_Entry$aiLearning21$g = _Entry$aiLearning21.getTableData) === null || _Entry$aiLearning21$g === void 0 ? void 0 : _Entry$aiLearning21$g.call(_Entry$aiLearning21);
            if (table) {
              var _Entry$aiLearning22, _Entry$aiLearning22$g, _select$10;
              var _Entry$aiLearning$get33 = (_Entry$aiLearning22 = Entry.aiLearning) === null || _Entry$aiLearning22 === void 0 || (_Entry$aiLearning22$g = _Entry$aiLearning22.getTableData) === null || _Entry$aiLearning22$g === void 0 ? void 0 : _Entry$aiLearning22$g.call(_Entry$aiLearning22),
                _Entry$aiLearning$get34 = _Entry$aiLearning$get33.select,
                select = _Entry$aiLearning$get34 === void 0 ? [] : _Entry$aiLearning$get34,
                _Entry$aiLearning$get35 = _Entry$aiLearning$get33.fields,
                fields = _Entry$aiLearning$get35 === void 0 ? [] : _Entry$aiLearning$get35;
              return fields[select === null || select === void 0 || (_select$10 = select[0]) === null || _select$10 === void 0 ? void 0 : _select$10[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning23, _Entry$aiLearning23$g;
            var table = (_Entry$aiLearning23 = Entry.aiLearning) === null || _Entry$aiLearning23 === void 0 || (_Entry$aiLearning23$g = _Entry$aiLearning23.getTableData) === null || _Entry$aiLearning23$g === void 0 ? void 0 : _Entry$aiLearning23$g.call(_Entry$aiLearning23);
            if (table) {
              var _Entry$aiLearning24, _Entry$aiLearning24$g, _select$11;
              var _Entry$aiLearning$get36 = (_Entry$aiLearning24 = Entry.aiLearning) === null || _Entry$aiLearning24 === void 0 || (_Entry$aiLearning24$g = _Entry$aiLearning24.getTableData) === null || _Entry$aiLearning24$g === void 0 ? void 0 : _Entry$aiLearning24$g.call(_Entry$aiLearning24),
                _Entry$aiLearning$get37 = _Entry$aiLearning$get36.select,
                select = _Entry$aiLearning$get37 === void 0 ? [] : _Entry$aiLearning$get37,
                _Entry$aiLearning$get38 = _Entry$aiLearning$get36.fields,
                fields = _Entry$aiLearning$get38 === void 0 ? [] : _Entry$aiLearning$get38;
              return fields[select === null || select === void 0 || (_select$11 = select[0]) === null || _select$11 === void 0 ? void 0 : _select$11[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning25, _Entry$aiLearning25$g;
            var table = (_Entry$aiLearning25 = Entry.aiLearning) === null || _Entry$aiLearning25 === void 0 || (_Entry$aiLearning25$g = _Entry$aiLearning25.getTableData) === null || _Entry$aiLearning25$g === void 0 ? void 0 : _Entry$aiLearning25$g.call(_Entry$aiLearning25);
            if (table) {
              var _Entry$aiLearning26, _Entry$aiLearning26$g, _select$12;
              var _Entry$aiLearning$get39 = (_Entry$aiLearning26 = Entry.aiLearning) === null || _Entry$aiLearning26 === void 0 || (_Entry$aiLearning26$g = _Entry$aiLearning26.getTableData) === null || _Entry$aiLearning26$g === void 0 ? void 0 : _Entry$aiLearning26$g.call(_Entry$aiLearning26),
                _Entry$aiLearning$get40 = _Entry$aiLearning$get39.select,
                select = _Entry$aiLearning$get40 === void 0 ? [] : _Entry$aiLearning$get40,
                _Entry$aiLearning$get41 = _Entry$aiLearning$get39.fields,
                fields = _Entry$aiLearning$get41 === void 0 ? [] : _Entry$aiLearning$get41;
              return fields[select === null || select === void 0 || (_select$12 = select[0]) === null || _select$12 === void 0 ? void 0 : _select$12[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning27, _Entry$aiLearning27$g;
            var table = (_Entry$aiLearning27 = Entry.aiLearning) === null || _Entry$aiLearning27 === void 0 || (_Entry$aiLearning27$g = _Entry$aiLearning27.getTableData) === null || _Entry$aiLearning27$g === void 0 ? void 0 : _Entry$aiLearning27$g.call(_Entry$aiLearning27);
            if (table) {
              var _Entry$aiLearning28, _Entry$aiLearning28$g, _select$13;
              var _Entry$aiLearning$get42 = (_Entry$aiLearning28 = Entry.aiLearning) === null || _Entry$aiLearning28 === void 0 || (_Entry$aiLearning28$g = _Entry$aiLearning28.getTableData) === null || _Entry$aiLearning28$g === void 0 ? void 0 : _Entry$aiLearning28$g.call(_Entry$aiLearning28),
                _Entry$aiLearning$get43 = _Entry$aiLearning$get42.select,
                select = _Entry$aiLearning$get43 === void 0 ? [] : _Entry$aiLearning$get43,
                _Entry$aiLearning$get44 = _Entry$aiLearning$get42.fields,
                fields = _Entry$aiLearning$get44 === void 0 ? [] : _Entry$aiLearning$get44;
              return fields[select === null || select === void 0 || (_select$13 = select[0]) === null || _select$13 === void 0 ? void 0 : _select$13[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_5'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_5'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_5'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
            var a, b, c, d, e;
            return _regenerator["default"].wrap(function (_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  _context5.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e]);
                case 1:
                  return _context5.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_predict_6: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning29, _Entry$aiLearning29$g;
            var table = (_Entry$aiLearning29 = Entry.aiLearning) === null || _Entry$aiLearning29 === void 0 || (_Entry$aiLearning29$g = _Entry$aiLearning29.getTableData) === null || _Entry$aiLearning29$g === void 0 ? void 0 : _Entry$aiLearning29$g.call(_Entry$aiLearning29);
            if (table) {
              var _Entry$aiLearning30, _Entry$aiLearning30$g, _select$14;
              var _Entry$aiLearning$get45 = (_Entry$aiLearning30 = Entry.aiLearning) === null || _Entry$aiLearning30 === void 0 || (_Entry$aiLearning30$g = _Entry$aiLearning30.getTableData) === null || _Entry$aiLearning30$g === void 0 ? void 0 : _Entry$aiLearning30$g.call(_Entry$aiLearning30),
                _Entry$aiLearning$get46 = _Entry$aiLearning$get45.select,
                select = _Entry$aiLearning$get46 === void 0 ? [] : _Entry$aiLearning$get46,
                _Entry$aiLearning$get47 = _Entry$aiLearning$get45.fields,
                fields = _Entry$aiLearning$get47 === void 0 ? [] : _Entry$aiLearning$get47;
              return fields[select === null || select === void 0 || (_select$14 = select[0]) === null || _select$14 === void 0 ? void 0 : _select$14[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning31, _Entry$aiLearning31$g;
            var table = (_Entry$aiLearning31 = Entry.aiLearning) === null || _Entry$aiLearning31 === void 0 || (_Entry$aiLearning31$g = _Entry$aiLearning31.getTableData) === null || _Entry$aiLearning31$g === void 0 ? void 0 : _Entry$aiLearning31$g.call(_Entry$aiLearning31);
            if (table) {
              var _Entry$aiLearning32, _Entry$aiLearning32$g, _select$15;
              var _Entry$aiLearning$get48 = (_Entry$aiLearning32 = Entry.aiLearning) === null || _Entry$aiLearning32 === void 0 || (_Entry$aiLearning32$g = _Entry$aiLearning32.getTableData) === null || _Entry$aiLearning32$g === void 0 ? void 0 : _Entry$aiLearning32$g.call(_Entry$aiLearning32),
                _Entry$aiLearning$get49 = _Entry$aiLearning$get48.select,
                select = _Entry$aiLearning$get49 === void 0 ? [] : _Entry$aiLearning$get49,
                _Entry$aiLearning$get50 = _Entry$aiLearning$get48.fields,
                fields = _Entry$aiLearning$get50 === void 0 ? [] : _Entry$aiLearning$get50;
              return fields[select === null || select === void 0 || (_select$15 = select[0]) === null || _select$15 === void 0 ? void 0 : _select$15[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning33, _Entry$aiLearning33$g;
            var table = (_Entry$aiLearning33 = Entry.aiLearning) === null || _Entry$aiLearning33 === void 0 || (_Entry$aiLearning33$g = _Entry$aiLearning33.getTableData) === null || _Entry$aiLearning33$g === void 0 ? void 0 : _Entry$aiLearning33$g.call(_Entry$aiLearning33);
            if (table) {
              var _Entry$aiLearning34, _Entry$aiLearning34$g, _select$16;
              var _Entry$aiLearning$get51 = (_Entry$aiLearning34 = Entry.aiLearning) === null || _Entry$aiLearning34 === void 0 || (_Entry$aiLearning34$g = _Entry$aiLearning34.getTableData) === null || _Entry$aiLearning34$g === void 0 ? void 0 : _Entry$aiLearning34$g.call(_Entry$aiLearning34),
                _Entry$aiLearning$get52 = _Entry$aiLearning$get51.select,
                select = _Entry$aiLearning$get52 === void 0 ? [] : _Entry$aiLearning$get52,
                _Entry$aiLearning$get53 = _Entry$aiLearning$get51.fields,
                fields = _Entry$aiLearning$get53 === void 0 ? [] : _Entry$aiLearning$get53;
              return fields[select === null || select === void 0 || (_select$16 = select[0]) === null || _select$16 === void 0 ? void 0 : _select$16[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning35, _Entry$aiLearning35$g;
            var table = (_Entry$aiLearning35 = Entry.aiLearning) === null || _Entry$aiLearning35 === void 0 || (_Entry$aiLearning35$g = _Entry$aiLearning35.getTableData) === null || _Entry$aiLearning35$g === void 0 ? void 0 : _Entry$aiLearning35$g.call(_Entry$aiLearning35);
            if (table) {
              var _Entry$aiLearning36, _Entry$aiLearning36$g, _select$17;
              var _Entry$aiLearning$get54 = (_Entry$aiLearning36 = Entry.aiLearning) === null || _Entry$aiLearning36 === void 0 || (_Entry$aiLearning36$g = _Entry$aiLearning36.getTableData) === null || _Entry$aiLearning36$g === void 0 ? void 0 : _Entry$aiLearning36$g.call(_Entry$aiLearning36),
                _Entry$aiLearning$get55 = _Entry$aiLearning$get54.select,
                select = _Entry$aiLearning$get55 === void 0 ? [] : _Entry$aiLearning$get55,
                _Entry$aiLearning$get56 = _Entry$aiLearning$get54.fields,
                fields = _Entry$aiLearning$get56 === void 0 ? [] : _Entry$aiLearning$get56;
              return fields[select === null || select === void 0 || (_select$17 = select[0]) === null || _select$17 === void 0 ? void 0 : _select$17[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning37, _Entry$aiLearning37$g;
            var table = (_Entry$aiLearning37 = Entry.aiLearning) === null || _Entry$aiLearning37 === void 0 || (_Entry$aiLearning37$g = _Entry$aiLearning37.getTableData) === null || _Entry$aiLearning37$g === void 0 ? void 0 : _Entry$aiLearning37$g.call(_Entry$aiLearning37);
            if (table) {
              var _Entry$aiLearning38, _Entry$aiLearning38$g, _select$18;
              var _Entry$aiLearning$get57 = (_Entry$aiLearning38 = Entry.aiLearning) === null || _Entry$aiLearning38 === void 0 || (_Entry$aiLearning38$g = _Entry$aiLearning38.getTableData) === null || _Entry$aiLearning38$g === void 0 ? void 0 : _Entry$aiLearning38$g.call(_Entry$aiLearning38),
                _Entry$aiLearning$get58 = _Entry$aiLearning$get57.select,
                select = _Entry$aiLearning$get58 === void 0 ? [] : _Entry$aiLearning$get58,
                _Entry$aiLearning$get59 = _Entry$aiLearning$get57.fields,
                fields = _Entry$aiLearning$get59 === void 0 ? [] : _Entry$aiLearning$get59;
              return fields[select === null || select === void 0 || (_select$18 = select[0]) === null || _select$18 === void 0 ? void 0 : _select$18[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning39, _Entry$aiLearning39$g;
            var table = (_Entry$aiLearning39 = Entry.aiLearning) === null || _Entry$aiLearning39 === void 0 || (_Entry$aiLearning39$g = _Entry$aiLearning39.getTableData) === null || _Entry$aiLearning39$g === void 0 ? void 0 : _Entry$aiLearning39$g.call(_Entry$aiLearning39);
            if (table) {
              var _Entry$aiLearning40, _Entry$aiLearning40$g, _select$19;
              var _Entry$aiLearning$get60 = (_Entry$aiLearning40 = Entry.aiLearning) === null || _Entry$aiLearning40 === void 0 || (_Entry$aiLearning40$g = _Entry$aiLearning40.getTableData) === null || _Entry$aiLearning40$g === void 0 ? void 0 : _Entry$aiLearning40$g.call(_Entry$aiLearning40),
                _Entry$aiLearning$get61 = _Entry$aiLearning$get60.select,
                select = _Entry$aiLearning$get61 === void 0 ? [] : _Entry$aiLearning$get61,
                _Entry$aiLearning$get62 = _Entry$aiLearning$get60.fields,
                fields = _Entry$aiLearning$get62 === void 0 ? [] : _Entry$aiLearning$get62;
              return fields[select === null || select === void 0 || (_select$19 = select[0]) === null || _select$19 === void 0 ? void 0 : _select$19[5]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_regression_predict_6'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_predict_6'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          ATTR6: 11
        },
        "class": 'ai_learning',
        isNotFor: ['regression_attr_6'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
            var a, b, c, d, e, f;
            return _regenerator["default"].wrap(function (_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  f = script.getNumberValue('ATTR6', script);
                  _context6.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e, f]);
                case 1:
                  return _context6.abrupt("return", Entry.aiLearning.getPredictResult());
                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      },
      get_regression_accuracy: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [],
        events: {},
        def: {
          type: 'get_regression_accuracy'
        },
        pyHelpDef: {
          params: [],
          type: 'get_regression_accuracy'
        },
        paramsKeyMap: {},
        "class": 'ai_learning',
        isNotFor: ['ai_learning_regression'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
            var _Entry$aiLearning41;
            return _regenerator["default"].wrap(function (_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", (_Entry$aiLearning41 = Entry.aiLearning) === null || _Entry$aiLearning41 === void 0 || (_Entry$aiLearning41 = _Entry$aiLearning41.getTrainResult()) === null || _Entry$aiLearning41 === void 0 ? void 0 : _Entry$aiLearning41.rsquared);
                case 1:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_regression'
      }
    };
  }
};